var _g, _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cash_svg__clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 47,
    rx: 7.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.408 6.679c-.934 0-1.83.376-2.49 1.046l-9.535 9.668v8.929h26.416c2.918 0 5.283-2.399 5.283-5.358h3.523V6.68H29.408z",
    fill: "#F0915A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 23.643V4h-8.754c-1.459 0-2.642 1.2-2.642 2.679v14.285c0 1.48 1.183 2.679 2.642 2.679H64z",
    fill: "#555A6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.843 31.678v-18.75c0-.986-.789-1.785-1.762-1.785H13.86c-.973 0-1.761.799-1.761 1.785v18.75c0 .987.788 1.786 1.76 1.786h35.222c.973 0 1.761-.8 1.761-1.786z",
    fill: "#78AF41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.741 27.214v-9.821c0-.493.395-.893.88-.893.973 0 1.762-.8 1.762-1.786 0-.493.394-.893.88-.893H44.68c.486 0 .88.4.88.893 0 .986.789 1.786 1.761 1.786.486 0 .88.4.88.893v9.821a.887.887 0 01-.88.893c-.972 0-1.76.8-1.76 1.786a.887.887 0 01-.881.893H18.263c-.486 0-.88-.4-.88-.893 0-.987-.789-1.786-1.761-1.786-.487 0-.88-.4-.88-.893z",
    fill: "#466932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.471 29c3.648 0 6.604-2.998 6.604-6.696 0-3.698-2.956-6.697-6.604-6.697-3.647 0-6.604 2.998-6.604 6.697 0 3.698 2.957 6.696 6.604 6.696z",
    fill: "#78AF41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.962 7.725l-8.29 8.405a1.803 1.803 0 000 2.526l.302.306a5.232 5.232 0 007.472 0l3.308-3.355H43.8c2.918 0 5.283-2.398 5.283-5.357V6.68h-12.63c-.934 0-1.83.376-2.49 1.046zM31.471 37.929h-7.933c-.934 0-1.83.376-2.49 1.046l-3.96 4.013 4.99 5.06 2.42-2.454c.33-.334.778-.522 1.245-.522h5.728c1.945 0 3.522-1.6 3.522-3.572s-1.577-3.571-3.522-3.571z",
    fill: "#FAB991"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.428 37.82a2.616 2.616 0 00-3.736 0l-7.15 7.251H25.743a1.75 1.75 0 00-1.246.523l-2.419 2.453 3.816 3.87 1.467-1.489h10.273c.701 0 1.373-.282 1.868-.784l7.925-8.036a2.705 2.705 0 000-3.788z",
    fill: "#F0915A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 54H4.469l11.118-11.273a.872.872 0 011.245 0l9.321 9.451a.902.902 0 010 1.263l-.551.56z",
    fill: "#555A6E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 47,
    rx: 7.5,
    stroke: "#E8E7EB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cash_svg__clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 47,
    rx: 7.5,
    fill: "#fff"
  })))));
}

export default SvgCash;